import { render, staticRenderFns } from "./indexB.vue?vue&type=template&id=ff7849c8&scoped=true"
import script from "./indexB.vue?vue&type=script&lang=js"
export * from "./indexB.vue?vue&type=script&lang=js"
import style0 from "./indexB.vue?vue&type=style&index=0&id=ff7849c8&prod&lang=less&scoped=true"
import style1 from "./indexB.vue?vue&type=style&index=1&id=ff7849c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7849c8",
  null
  
)

export default component.exports